<template>
<div class="digital-body-wrap">
  <HeaderBar>
      <img
        v-if="!is_collect"
        class="fav-img"
        src="../../assets/images/unfav.png"
        alt="收藏"
        @click="onFavClick"
      />
      <img
        v-else
        class="fav-img"
        src="../../assets/images/fav2.png"
        alt="取消收藏"
        @click="onUnfavClick"
      />
      <!--<img
        class="share-img"
        src="../../assets/images/share.png"
        alt="分享"
        @click="onShareClick"
      />-->
    </HeaderBar>
  <div class="view digitalDetail-view">
    <div class="view__wrap">
      <div class="digital-content">
          <div class="title">{{ title }}</div>
          <div class="author-info-wrap" @click="onUserClick">
            <img v-if="!!avatar" class="avatar" :src="avatar" />
            <img v-else class="avatar" src="../../assets/images/default_avatar.png" />
            <div class="detail-info-wrap">
              <div class="name">{{nickname}}</div>
              <div class="text--sub">{{  `${publish_date} · 报告发布时间：${report_time}`  }}</div>
            </div>
          </div>
          <div class="time-range-wrap">
            {{ `发布机构：${source}` }}
          </div>
          <div class="content-wrap" v-html="content"></div>
          <div class="tag-list">
            <TagItem
              v-for="item in tagList"
              :key="item.id"
              v-bind="item"
              :isRound="true"
            />
          </div>
          <div class="tip-wrap text--sub">
            本文内容仅代表作者个人观点，本站只提供参考并不构成
            任何投资及建议。（若存在内容、版权或其他问题，请联
            系：jiangdr@igreen.org）
          </div>
        </div>
    </div>
      
    <!-- <footer class="footer" v-if="osType.os === 'android'" @click="downloadReport">下载完整报告（PDF）</footer>
    <footer class="footer" @click="viewReport">查看完整报告（PDF）</footer> -->
    
  </div>
      <footer class="footer-wrap">
        <span class="footer-item download"
            v-if="osType.os == 'android'"
            @click="downloadReport">下载完整报告（PDF）</span>
        <span class="footer-item view-pdf" @click="viewReport">查看完整报告</span>
      </footer>
  </div>
</template>
<script>
import { Toast } from 'mint-ui'

import {getOS} from '../../utils/storageUtil'
import apiConst from '../../consts/apiConst';
import apiUtil from '../../utils/apiUtil';
import HeaderBar from '../../components/HeaderBar';
import TagItem from '../../components/TagItem';
export default {
  name: 'digitalDetail',
  components: {
    HeaderBar,
    TagItem
  },
  data() {
    return {
      id: 0,
      avatar: '',
      nickname: '',
      publish_date: '',
      title: '',
      report_time: '',
      content: '',
      tagList: [],
      dir_id: 0,
      is_collect: 0,
      source: '',
      osType: '',
      downloadPdfUrl: ''
    };
  },
  created() {
    const id = this.$route.query.id;
    const dir_id = this.$route.query.dir_id;
    this.id = id;
    this.dir_id = dir_id;
    this.init(id, dir_id);
    this.osType = getOS();
  },
  methods: {
    async init(id, dir_id) {
      const res = await apiUtil.post(apiConst.getDigitalDetail, { id, dir_id });
      if (res && res.success) {
        const {
          avatar,
          nickname,
          publish_date,
          tags,
          title,
          report_time,
          action_id,
          is_admin_publish,
          source
        } = res.list;
        this.downloadPdfUrl = res.neaf[0]
        this.avatar = avatar;
        this.nickname = nickname;
        this.publish_date = publish_date;
        this.title = title;
        document.title = this.title
        this.tagList = tags;
        this.report_time = report_time;
        this.action_id = action_id;
        this.is_admin_publish = is_admin_publish;
        this.source = source;
        this.content = res.content;
        this.is_collect = res.is_collect;
      } else {
        this.$router.go(-1);
      }
    },

    async onFavClick() {
      const res = await apiUtil.post(apiConst.submitFav, {
        id: this.id,
        type: 2
      });
      if (res.success) {
        this.is_collect = 1;
        Toast({
          message: '收藏成功',
          duration: 1000,
          background: '#8FC31E'
        });
      }
    },

    async onUnfavClick() {
      const res = await apiUtil.post(apiConst.submitUnfav, {
        id: this.id,
        type: 2
      });
      if (res.success) {
        this.is_collect = 0;

        Toast({
          message: '已取消收藏',
          duration: 1000,
          background: '#8FC31E'
        });
      }
    },

    onUserClick() {
      this.$router.push({
        name: 'userCenter',
        query: {
          action_id: this.action_id,
          is_admin_publish: this.is_admin_publish
        }
      });
    },

    downloadReport(){
      console.log(this.downloadPdfUrl)
      window.HostApp.downFile(this.downloadPdfUrl);
    },

    viewReport(){
      this.$router.push({name: 'pdfViewer', query: {type:2, id: this.id, index: this.dir_id}})
    },

    onShareClick() {}
  }
};
</script>
<style lang="stylus" scoped>
.digital-body-wrap{
  position: relative;
  height: 100%;
  // overflow-y: auto;
  // -webkit-overflow-scrolling: touch;
}

.digitalDetail-view {
    padding: 88px 36px 100px 36px;
    min-height:101%;
    padding-bottom:100px;

    .title{
      border-top: 1PX solid #eee;
        padding-top: 30px;
        color: #333;
        font-size: 48px;
        font-weight: bold;
        line-height: 67px;
        margin-bottom: 46px;
    }
    .author-info-wrap {
        display: flex;
        align-items: center;
        margin-bottom: 36px;
        .avatar {
            width: 80px;
            height: 80px;
            border-radius: 50px;
            margin-right: 36px;
        }

        .detail-info-wrap {
            .name{
                font-size: 32px;
                font-weight: bold;
                color: #333;
                margin-bottom: 14px;
            }
        }
    }

    .time-range-wrap {
        width:678px;
        height:88px;
        background:rgba(248,249,251,1);
        border-radius:8px;
        margin-bottom: 68px;
        line-height: 88px;
        text-align: center;
    }

    .content-wrap {
      color: #333;
        line-height: 54px;
     font-size: 30px;
     text-align: justify;
    }

    .tag-list {
      margin: 44px 0
      .tag-item-comp {
        margin-right: 35px
      }
    }

    .tip-wrap {
      width: 600px;
      margin: 0 auto;
      line-height: 46px;
      margin-bottom:40px;
    }
    
}
.footer-wrap {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 99;
    height: 100px;
    display: flex;

    .footer-item {
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 1;
      color: #fff;
      background-color: #fff;
      font-size: 30px;

      &.download {
        background-color: #8FC31E;
      }

      &.view-pdf {
        background-color:#43474D;
      }
    }
  }
</style>
<style scoped>
.digitalDetail-view .content-wrap >>> img{
  max-width: 100%;
  height: auto !important;
  display: block;
  margin: auto;
}
.digitalDetail-view .content-wrap >>> p{
  margin: 0;
    padding: 0;
}
</style>

